import ReactGA from 'react-ga4';
import { GA_PARAMS } from './types/ga';

const GA_ID = 'G-8PWH86LJ2L';

export const initGA = ({ userID }: { userID?: string }) => {
  ReactGA.initialize(GA_ID, {
    gaOptions: {
      debug_mode: import.meta.env.VITE_NODE_ENV !== 'production',
      userID: userID || '',
    },
    gtagOptions: {
      debug_mode: import.meta.env.VITE_NODE_ENV !== 'production',
    },
  });
};

export const logEvent = (event: string, params: GA_PARAMS) => {
  ReactGA.event(event, params);
};
